import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "../../../components/hooks/hooks";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import { backendApi } from "../../../api/apiService";
import { toast } from "react-toastify";
import moment from "moment";

export default function AddRequirement({
  setTabIndex,
  updateData = "default",
  recruitersListProps = [],
  managersListProps = [],
}) {
  const { userDetails, userData } = useSelector((state) => state.login);
  const [summary, setSummary] = useState("");
  const [remarks, setRemarks] = useState("");
  const [comments, setComments] = useState("");
  const [noOpenings, setNoOpenings] = useState("");
  const [dueDate, setDueDate] = useState(new Date());
  const [packageVal, setPackageVal] = useState("");
  const [projectName, setProjectName] = useState("");
  const [locationName, setLocationName] = useState("");
  const [status, setStatus] = useState("");
  const [managers, setManagers] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [priority, setPriority] = useState({ label: "Low ", value: "Low" });
  const [priorityList, setPriorityList] = useState([
    {
      label: "Low ",
      value: "Low",
    },
    {
      label: "Medium",
      value: "Medium",
    },
    {
      label: "High",
      value: "High",
    },
    {
      label: "Critical",
      value: "Critical",
    },
  ]);
  const [recruitersList, setRecruitersList] = useState(recruitersListProps);
  const [managersList, setManagersList] = useState(managersListProps);

  //? Initial useEffect
  useEffect(() => {
    // getUserList();
    if (updateData !== "default") initUpdateData(updateData);
  }, [updateData]);

  //?
  const initUpdateData = (updateData) => {
    if (updateData !== "default") {
      setSummary(updateData.recruitmentSummary.replace(/\\(['"])/g, "$1"));
      setRemarks(updateData.recruitmentRemarks.replace(/\\(['"])/g, "$1"));
      setNoOpenings(updateData.no_of_vacancy);
      setDueDate(new Date(updateData.due_date));
      setPackageVal(updateData.packageValue);
      setProjectName(updateData.projectName.replace(/\\(['"])/g, "$1"));
      setLocationName(updateData.locationName.replace(/\\(['"])/g, "$1"));
      setManagers(
        managersListProps.filter((obj) =>
          updateData.reportingManagers
            .split(",")
            .some((jbo) => obj.value === Number(jbo))
        )
      );
      setRecruiters(
        recruitersListProps.filter((obj) =>
          updateData.recruiters
            .split(",")
            .some((jbo) => obj.value === Number(jbo))
        )
      );
    }
  };
  //? Function to get UserList
  // const getUserList = () => {
  //   const api = {
  //     functionName: "userListing",
  //     site_id: userDetails[0].site_id,
  //   };
  //   backendApi(api).then((response) => {
  //     if (response.success === "1") {

  //       console.log("🚀 ~ managers ~ managers:", managers);
  //       console.log("🚀 ~ backendApi ~ recruiters:", recruiters);

  //       setRecruitersList(recruiters);
  //       setManagersList(managers);

  //       // console.log(
  //       //   "🚀 ~ backendApi ~ recruiters:",
  //       //   managers.filter((obj) =>
  //       //     updateData.reportingManagers
  //       //       .split(",")
  //       //       .some((jbo) => obj.value === jbo)
  //       //   )
  //       // );

  //       // console.log(
  //       //   "🚀 ~ backendApi ~ reportingManagers:",
  //       //   managers.filter((obj) =>
  //       //     updateData.reportingManagers
  //       //       .split(",")
  //       //       .some((jbo) => obj.value === jbo)
  //       //   )
  //       // );
  //     }
  //   });
  // };

  // useEffect(() => {
  //   console.log("tempRecruiters", tempRecruiters);
  //   setTimeout(() => {
  //     setRecruiters(tempRecruiters);
  //     setManagers(tempManagers);
  //   }, [300]);
  // }, [tempManagers, tempRecruiters]);

  //? Function to save new requirement
  const saveNewRequirement = () => {
    if (!fieldValidation()) {
      return false;
    }
    const api = {
      functionName: "createNewRequirement",
      summary: summary.replace(/['"]/g, "\\$&"),
      remarks: remarks.replace(/['"]/g, "\\$&"),
      noOpenings,
      dueDate,
      packageVal,
      projectName: projectName.replace(/['"]/g, "\\$&"),
      locationName: locationName.replace(/['"]/g, "\\$&"),
      created_by: userData[0].id,
      status: "Open",
      managers: managers.map((o) => String(o.value)).join(","),
      recruiters: recruiters.map((o) => String(o.value)).join(","),
      updatedOn: null,
      siteId: userDetails[0].site_id,
      priority: priority.value,
      comments: comments.replace(/['"]/g, "\\$&"),
    };
    backendApi(api).then((response) => {
      if (response.success === "1") {
        toast.success("New requirement added successfully", {
          containerId: "D",
        });
        setTabIndex(1);
      } else {
        toast.error("Something went wrong", { containerId: "D" });
        console.error("Something went wrong", response);
      }
    });
  };

  const updateNewRequirement = () => {
    const api = {
      functionName: "updateNewRequirement",
      summary: summary.replace(/['"]/g, "\\$&"),
      remarks: remarks.replace(/['"]/g, "\\$&"),
      noOpenings,
      dueDate,
      packageVal,
      projectName: projectName.replace(/['"]/g, "\\$&"),
      locationName: locationName.replace(/['"]/g, "\\$&"),
      status: "Open",
      managers: managers.map((o) => String(o.value)).join(","),
      recruiters: recruiters.map((o) => String(o.value)).join(","),
      updatedOn: new Date(),
      requirementId: updateData.id,
      priority: priority.value,
      comments: comments.replace(/['"]/g, "\\$&"),
    };
    console.log("🚀 ~ updateNewRequirement ~ api:", api);
    backendApi(api).then((response) => {
      if (response.success === "1") {
        toast.success("New requirement added successfully", {
          containerId: "D",
        });
        setTabIndex(1);
      } else {
        toast.error("Something went wrong", { containerId: "D" });
        console.error("Something went wrong", response);
      }
    });
  };

  //? Function for fieldValidations
  const fieldValidation = () => {
    if (summary === "") {
      toast.warn("Job Summary is required", { containerId: "D" });
      return false;
    } else if (packageVal === "") {
      toast.warn("Please specify Salary Package", { containerId: "D" });
      return false;
    } else if (
      moment(dueDate).format("dd-MMM-YYYY") ===
      moment(new Date()).format("dd-MMM-YYYY")
    ) {
      toast.warn("Due date must be greater current date", { containerId: "D" });
      return false;
    } else if (managers.length === 0) {
      toast.warn("Atleast 1 manager required", { containerId: "D" });
      return false;
    } else if (recruiters.length === 0) {
      toast.warn("Atleast 1 recruiters should be assigned", {
        containerId: "D",
      });
      return false;
    } else return true;
  };
  return (
    <div className="m-4">
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Job Description
              <span className="text-danger ml-1">*</span>{" "}
            </label>
            <textarea
              className="form-control"
              rows="2"
              value={summary}
              onChange={(e) =>
                e.target.value.length < 500 && setSummary(e.target.value)
              }
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Remarks
            </label>
            <textarea
              rows="2"
              className="form-control"
              value={remarks}
              onChange={(e) =>
                e.target.value.length < 2000 && setRemarks(e.target.value)
              }
            ></textarea>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              No Of Opening
              <span className="text-danger ml-1">*</span>{" "}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="No Of Opening"
              name="no of opening"
              id="no of opening"
              value={noOpenings}
              onChange={(e) => setNoOpenings(e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Expected Due Date
              <span className="text-danger ml-1">*</span>{" "}
            </label>
            <ReactDatePicker
              selected={dueDate}
              minDate={new Date()}
              dateFormat={"dd-MMM-yyyy"}
              className="form-control"
              onChange={(date) => setDueDate(date)}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Salary Package Offered
              <span className="text-danger ml-1">*</span>{" "}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Package"
              value={packageVal}
              onChange={(e) => setPackageVal(e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Project Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Project"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Location Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Location"
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Requirement Priority
              <span className="text-danger ml-1">*</span>{" "}
            </label>
            <Select
              name="colors"
              value={priority}
              options={priorityList}
              classNamePrefix="select"
              menuPlacement="top"
              onChange={(e) => {
                setPriority(e);
              }}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Recruiters Assigned
              <span className="text-danger ml-1">*</span>{" "}
            </label>
            <Select
              isMulti
              name="colors"
              value={recruiters}
              options={recruitersList}
              // className="basic-multi-select"
              classNamePrefix="select"
              menuPlacement="top"
              onChange={setRecruiters}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Managers Assigned
              <span className="text-danger ml-1">*</span>{" "}
            </label>
            <Select
              isMulti
              name="colors"
              value={managers}
              options={managersList}
              // className="basic-multi-select"
              classNamePrefix="select"
              menuPlacement="top"
              onChange={setManagers}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Status
              <span className="text-danger ml-1">*</span>{" "}
            </label>
            <select
              class="form-control"
              aria-label="Default select example"
              disabled
            >
              <option selected>Select</option>
              <option value="1" selected>
                Open
              </option>
              {/* <option value="2">Closed</option> */}
            </select>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="" className="form-label">
              Comments
            </label>
            <textarea
              className="form-control"
              rows="2"
              value={comments}
              onChange={(e) =>
                e.target.value.length < 1000 && setComments(e.target.value)
              }
            />
          </div>
        </div>
      </div>
      <div className="childIssueses">
        <button
          className="btn-btn btn btn-btn1 btn-sm me-2"
          // onClick={goBack}
        >
          Cancel
        </button>
        {updateData == "default" ? (
          <button
            className="btn-btn btn btn-btn2 btn-sm"
            onClick={() => saveNewRequirement()}
          >
            Save
          </button>
        ) : (
          <button
            className="btn-btn btn btn-btn2 btn-sm"
            onClick={() => updateNewRequirement()}
          >
            Update
          </button>
        )}
      </div>
    </div>
  );
}
